/**
 * @file 认证
 * @author zhaomiaoyuan
 */
// @ts-nocheck

import React from 'react';
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';
import PropTypes from 'prop-types';
import {recordProxy, storeChannelId} from '../../util';
import {
    fetchAttestSendCode,
    fetchDelegationAuth,
    fetchDelegationType,
    fetchDelegationSubmit,
    fetchEntity,
    fetchFlashNum
} from '../../actions/attestAction';
import {getQueryString} from '../../util';
import Banner from './banner';
import Advantage from './advantage';
import Features from './features';
import Procedure from '../attest/authProcedure';

import './index.less';

class Attest extends React.Component<any, any> {
    constructor(props) {
        super(props);
        // const {params = {}} = props.match || {};
        this.state = {
            companyName: '',
            companyAddress: '',
            code: '',
            phoneNumber: '',
            count: 60,
            getCaptchaTip: '获取验证码',
            captchaBtnStatus: true, // 获取验证码按钮状态
            currentTabsKey: 1,
            attestType: '0',
            authMethodOptShow: false,
            authType: '0',
            authTypeOptShow: false,
            agreeProtocol: false,
            formData: {},
            isSimple: false,
            // isSimple: params.type === 'simple',
            loading: false,
            channelId: getQueryString('zd'),
            anchor: getQueryString('anchor')
        };
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        storeChannelId(this.state.channelId);
        recordProxy(
            this.state.anchor ? 'attest-submit-pv' : 'attest-pv',
            'click',
            JSON.stringify({
                tag: this.state.anchor ? 'attest-submit-page-pv' : 'attest-page-pv'
            })
        );
    }
    render () {
        return (
            <div className="page-call-auth">
                {/* 头图 */}
                <Banner
                    {...this.props}
                    anchor={this.state.anchor}/>
                {/* 产品价值 */}
                <Advantage
                    {...this.props}
                    title="产品价值"
                    anchor={this.state.anchor}/>
                <Features
                    {...this.props}
                    title="产品功能"
                    anchor={this.state.anchor}/>
                <Procedure
                    {...this.props}
                    title="认证流程"
                    anchor={this.state.anchor}/>
            </div>
        );
    }
}
Attest.propTypes = {
    location: PropTypes.object,
    history: PropTypes.object
};
function mapStateToProps(state) {
    return {
        userInfo: state.userInfo,
        flashNum: state.myAttestReducer.flashNum,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        fetchAttestSendCode: obj => fetchAttestSendCode(dispatch, obj),
        fetchDelegationAuth: obj => fetchDelegationAuth(dispatch, obj),
        fetchDelegationType: obj => fetchDelegationType(dispatch, obj),
        fetchDelegationSubmit: obj => fetchDelegationSubmit(dispatch, obj),
        fetchEntity: obj => fetchEntity(dispatch, obj),
        fetchFlashNum: () => fetchFlashNum(dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Attest));
